import { useContext, useEffect, useMemo } from 'react';
import { UploadContext } from './UploadContext';
import type { UploadContextType, UploadContextHookReturn } from './types';

export const useUploadContext = (containerId: string): UploadContextHookReturn => {
  const context = useContext<UploadContextType | null>(UploadContext);

  if (context === null) {
    throw new Error('useUploadContext was used outside of the context provider.');
  }

  const {
    register,
    canUploadMoreVideos,
    getQueueState,
    getFunctions,
    mediaCount,
    inflexibleMediaLimit,
  } = context;

  useEffect(() => register(containerId), [containerId, register]);

  const functions = useMemo(() => getFunctions(containerId), [containerId, getFunctions]);

  const queueState = getQueueState(containerId);

  return {
    ...functions,
    ...queueState,
    canUploadMoreVideos,
    mediaCount,
    inflexibleMediaLimit,
  };
};
